export const getExactUrlStyles = () => ({
  listHeader: {
    display: 'flex',
    gap: '10px',
    alignItems: 'start',
    padding: '10px 0',
    '& .url': {
      width: '322px',
    },
    '& .bid': {
      width: '120px',
    },
  },
  listFooter: {
    padding: '10px 0',
  },
  exactUrlEditRowContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',
    '& .exact-url-edit-row': {
      display: 'flex',
      gap: '10px',
      '& .website-edit': {
        width: '320px',
        '& .fui-Input': {
          maxWidth: '200px',
        },
        "& div[role='alert'] .error": {
          color: '#A80000',
          marginTop: '10px',
          marginBottom: '10px',
        },
      },
      '& .column-bid-edit': {
        width: '120px',
        '& .fui-Input': {
          width: '100%',
        },
        "& div[role='alert'] .error": {
          color: '#A80000',
          marginTop: '10px',
          marginBottom: '10px',
        },
      },
    },
    '& .duplicate-error': {
      color: '#A80000',
      marginTop: '10px',
    },
  },
});
